export default __webpack_public_path__ + "static/media/blueWaveBackground.40efa8a6.png";